import { recipes } from "../data";

function twemojiUrl(emoji: string): string {
  const codepoints = [...emoji]
    .map(c => c.codePointAt(0)!.toString(16))
    .filter(cp => cp !== 'fe0f');
  return `${import.meta.env.BASE_URL}images/emoji/${codepoints.join('-')}.svg`;
}

// Maps ingredient id → Twemoji SVG URL
export const fluentEmojiMap: Record<string, string> = {
  // ─── Vegetables ───────────────────────────────────────────────────────────
  tomato:          twemojiUrl('🍅'),
  onion:           twemojiUrl('🧅'),
  garlic:          twemojiUrl('🧄'),
  carrot:          twemojiUrl('🥕'),
  pepper:          twemojiUrl('🫑'),
  cucumber:        twemojiUrl('🥒'),
  potato:          twemojiUrl('🥔'),
  spinach:         twemojiUrl('🥬'),
  eggplant:        twemojiUrl('🍆'),
  zucchini:        twemojiUrl('🥒'),
  mushroom:        twemojiUrl('🍄'),
  broccoli:        twemojiUrl('🥦'),
  corn:            twemojiUrl('🌽'),
  sweet_potato:    twemojiUrl('🍠'),
  pumpkin:         twemojiUrl('🎃'),
  cabbage:         twemojiUrl('🥬'),
  green_beans:     twemojiUrl('🫛'),
  parsley:         twemojiUrl('🌿'),
  mint:            twemojiUrl('🌿'),
  coriander:       twemojiUrl('🌿'),
  green_onion:     twemojiUrl('🌿'),
  celery:          twemojiUrl('🌿'),
  leek:            twemojiUrl('🌿'),
  okra:            twemojiUrl('🌿'),
  beetroot:        twemojiUrl('🍠'),
  turnip:          twemojiUrl('🧅'),
  cauliflower:     twemojiUrl('🥦'),
  // ─── Proteins ─────────────────────────────────────────────────────────────
  chicken:         twemojiUrl('🍗'),
  beef:            twemojiUrl('🥩'),
  lamb:            twemojiUrl('🍖'),
  eggs:            twemojiUrl('🥚'),
  minced_meat:     twemojiUrl('🥩'),
  turkey:          twemojiUrl('🍗'),
  veal:            twemojiUrl('🥩'),
  camel_meat:      twemojiUrl('🥩'),
  sausage:         twemojiUrl('🌭'),
  mortadella:      twemojiUrl('🥩'),
  duck:            twemojiUrl('🦆'),
  liver:           twemojiUrl('🫀'),
  // ─── Seafood ──────────────────────────────────────────────────────────────
  salmon:          twemojiUrl('🐟'),
  tuna:            twemojiUrl('🐠'),
  shrimp:          twemojiUrl('🦐'),
  fish:            twemojiUrl('🐟'),
  squid:           twemojiUrl('🦑'),
  sea_bass:        twemojiUrl('🐟'),
  sea_bream:       twemojiUrl('🐟'),
  sardine:         twemojiUrl('🐟'),
  mackerel:        twemojiUrl('🐟'),
  cod:             twemojiUrl('🐟'),
  halibut:         twemojiUrl('🐟'),
  red_mullet:      twemojiUrl('🐠'),
  anchovy:         twemojiUrl('🐟'),
  swordfish:       twemojiUrl('🐟'),
  snapper:         twemojiUrl('🐠'),
  grouper:         twemojiUrl('🐟'),
  pomfret:         twemojiUrl('🐟'),
  crab:            twemojiUrl('🦀'),
  lobster:         twemojiUrl('🦞'),
  octopus:         twemojiUrl('🐙'),
  mussels:         twemojiUrl('🦪'),
  tilapia:         twemojiUrl('🐟'),
  carp:            twemojiUrl('🐟'),
  catfish:         twemojiUrl('🐟'),
  trout:           twemojiUrl('🐟'),
  perch:           twemojiUrl('🐟'),
  mullet:          twemojiUrl('🐟'),
  eel:             twemojiUrl('🐍'),
  // ─── Dairy ────────────────────────────────────────────────────────────────
  cheese:          twemojiUrl('🧀'),
  milk:            twemojiUrl('🥛'),
  yogurt:          twemojiUrl('🥛'),
  butter:          twemojiUrl('🧈'),
  mozzarella:      twemojiUrl('🧀'),
  feta:            twemojiUrl('🧀'),
  halloumi:        twemojiUrl('🧀'),
  cream_cheese:    twemojiUrl('🧀'),
  condensed_milk:  twemojiUrl('🥛'),
  powdered_milk:   twemojiUrl('🥛'),
  cream:           twemojiUrl('🧈'),
  labneh:          twemojiUrl('🥣'),
  qashta:          twemojiUrl('🍮'),
  // ─── Grains ───────────────────────────────────────────────────────────────
  rice:            twemojiUrl('🍚'),
  pasta:           twemojiUrl('🍝'),
  bread:           twemojiUrl('🍞'),
  flour:           twemojiUrl('🌾'),
  oats:            twemojiUrl('🌾'),
  quinoa:          twemojiUrl('🌾'),
  barley:          twemojiUrl('🌾'),
  bulgur:          twemojiUrl('🍚'),
  couscous:        twemojiUrl('🍚'),
  freekeh:         twemojiUrl('🌾'),
  vermicelli:      twemojiUrl('🍝'),
  semolina:        twemojiUrl('🌾'),
  cornmeal:        twemojiUrl('🌽'),
  brown_rice:      twemojiUrl('🍚'),
  rice_noodles:    twemojiUrl('🍜'),
  sesame:          twemojiUrl('🌱'),
  // ─── Legumes ──────────────────────────────────────────────────────────────
  lentils:         twemojiUrl('🫘'),
  chickpeas:       twemojiUrl('🫘'),
  green_peas:      twemojiUrl('🫛'),
  black_eyed_peas: twemojiUrl('🫘'),
  kidney_beans:    twemojiUrl('🫘'),
  white_beans:     twemojiUrl('🫘'),
  mung_beans:      twemojiUrl('🫘'),
  broad_beans:     twemojiUrl('🫘'),
  // ─── Fruits ───────────────────────────────────────────────────────────────
  lemon:           twemojiUrl('🍋'),
  apple:           twemojiUrl('🍎'),
  banana:          twemojiUrl('🍌'),
  orange:          twemojiUrl('🍊'),
  strawberry:      twemojiUrl('🍓'),
  grape:           twemojiUrl('🍇'),
  watermelon:      twemojiUrl('🍉'),
  mango:           twemojiUrl('🥭'),
  peach:           twemojiUrl('🍑'),
  pear:            twemojiUrl('🍐'),
  pineapple:       twemojiUrl('🍍'),
  kiwi:            twemojiUrl('🥝'),
  cherry:          twemojiUrl('🍒'),
  melon:           twemojiUrl('🍈'),
  avocado:         twemojiUrl('🥑'),
  blueberry:       twemojiUrl('🫐'),
  coconut:         twemojiUrl('🥥'),
  pomegranate:     twemojiUrl('🍎'),
  date_fruit:      twemojiUrl('🌴'),
  fig:             twemojiUrl('🍇'),
  // ─── Condiments – Oils ────────────────────────────────────────────────────
  olive_oil:       twemojiUrl('🫙'),
  veg_oil:         twemojiUrl('🫙'),
  ghee:            twemojiUrl('🧈'),
  sesame_oil:      twemojiUrl('🫙'),
  // ─── Condiments – Spices ──────────────────────────────────────────────────
  salt:            twemojiUrl('🧂'),
  paprika:         twemojiUrl('🌶️'),
  chili_powder:    twemojiUrl('🌶️'),
  ginger:          twemojiUrl('🫚'),
  nutmeg:          twemojiUrl('🌰'),
  walnut:          'images/bc4d7466-e68d-4eee-ad78-5d0df6c793af.webp',
  chocolate:       twemojiUrl('🍫'),
  vanilla:         twemojiUrl('🌿'),
  black_pepper:    twemojiUrl('🖤'),
  cumin:           twemojiUrl('🟤'),
  turmeric:        twemojiUrl('🟡'),
  cinnamon:        twemojiUrl('🤎'),
  cardamom:        twemojiUrl('🫛'),
  baharat:         twemojiUrl('🫙'),
  saffron:         twemojiUrl('🌼'),
  cloves:          twemojiUrl('🌿'),
  bay_leaf:        twemojiUrl('🍂'),
  thyme:           twemojiUrl('🌿'),
  // ─── Condiments – Sweeteners ──────────────────────────────────────────────
  honey:           twemojiUrl('🍯'),
  molasses:        twemojiUrl('🍯'),
  powdered_sugar:  twemojiUrl('🧂'),
  sugar:           twemojiUrl('🍬'),
  brown_sugar:     twemojiUrl('🟫'),
  // ─── Condiments – Sauces & Pastes ─────────────────────────────────────────
  tomato_paste:    twemojiUrl('🍅'),
  soy_sauce:       twemojiUrl('🫙'),
  ketchup:         twemojiUrl('🍅'),
  rose_water:      twemojiUrl('🌹'),
  vinegar:         twemojiUrl('🫙'),
  baking_powder:   twemojiUrl('🧁'),
  tahini:          twemojiUrl('🌼'),
  pomegranate_mol: twemojiUrl('🍷'),
  // ─── Beverages ────────────────────────────────────────────────────────────
  water:           twemojiUrl('💧'),
  milk_drink:      twemojiUrl('🥛'),
  orange_juice:    twemojiUrl('🍊'),
  apple_juice:     twemojiUrl('🍎'),
  mango_juice:     twemojiUrl('🥭'),
  grape_juice:     twemojiUrl('🍇'),
  pom_juice:       twemojiUrl('🍷'),
  lemon_juice:     twemojiUrl('🍋'),
  hibiscus:        twemojiUrl('🌺'),
  coffee:          twemojiUrl('☕'),
  arabic_coffee:   twemojiUrl('☕'),
  green_tea:       twemojiUrl('🍵'),
  black_tea:       twemojiUrl('🍵'),
  mint_tea:        twemojiUrl('🍵'),
  coconut_water:   twemojiUrl('🥥'),
  laban:           twemojiUrl('🥛'),
  ayran:           twemojiUrl('🥛'),
  strawberry_juice:twemojiUrl('🍓'),
  watermelon_juice:twemojiUrl('🍉'),
  carrot_juice:    twemojiUrl('🥕'),
  jallab:          twemojiUrl('🍷'),
  tamarind_juice:  twemojiUrl('🧃'),
  rose_drink:      twemojiUrl('🌷'),
  sahlab:          twemojiUrl('🍵'),
};

export function emojiUrl(emoji: string): string {
  return twemojiUrl(emoji);
}

const CACHE_NAME = "smart-kitchen-images-v2";
let preloaded = false;

function putInCache(cache: Cache, url: string, res: Response) {
  if (res.ok || res.type === "opaque") {
    cache.put(url, res.clone()).catch(() => {});
  }
}

export function preloadFoodImages(): Promise<void> {
  if (preloaded || !("caches" in window)) return Promise.resolve();
  preloaded = true;
  const urls = [
    ...Object.values(fluentEmojiMap),
    ...recipes.map(r => r.image).filter(Boolean),
  ];
  return caches.open(CACHE_NAME).then(cache =>
    Promise.all(
      urls.map(url =>
        cache.match(url).then(hit =>
          hit ? null : fetch(url, { mode: url.startsWith("http") ? "cors" : "same-origin" })
            .then(res => putInCache(cache, url, res))
            .catch(() => {})
        )
      )
    )
  ).then(() => {});
}
